export default __webpack_public_path__ + "static/media/4-2_image05@2x.25d5b27c.png";